import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { GlobalHotKeys } from "react-hotkeys";

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return { open, close, isOpen };
};

export const ModalPortal = ({ isOpen, children }) => {
  const modalRoot = document.querySelector("body");
  const modalElement = document.createElement("dialog");

  useEffect(() => {
    modalElement.open = isOpen;
    modalElement.className = `modal show text-body`;
    modalElement.tabIndex = -1;
    modalElement.style.display = "block";

    document.body.classList.add("modal-open");

    modalRoot.appendChild(modalElement);
    return () => {
      document.body.classList.remove("modal-open");
      modalRoot.removeChild(modalElement);
    };
  });

  return createPortal(children, modalElement);
};

export const Modal = ({
  title,
  children,
  isOpen,
  onClose,
  isScrollable,
  size,
}) => {
  const scrollableClassName = isScrollable && "modal-dialog-scrollable";
  const sizeClassName = size && `modal-${size}`;

  const MODAL_KEY_MAP = {
    ESCAPE: ["esc"],
  };

  const modalKeymapHandler = {
    ESCAPE: onClose,
  };

  return (
    isOpen && (
      <ModalPortal isOpen={isOpen} size={size}>
        <GlobalHotKeys keyMap={MODAL_KEY_MAP} handlers={modalKeymapHandler} />
        <div className={`modal-dialog ${scrollableClassName} ${sizeClassName}`}>
          <div className="modal-content">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="close text-white"
                aria-label="Close"
                onClick={onClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </ModalPortal>
    )
  );
};
